import { useState, useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "cookie_consent";
const ANALYTICS_CONSENT_KEY = "analytics_consent";

export function CookieConsent() {
	const [showBanner, setShowBanner] = useState(false);
	const posthog = usePostHog();

	useEffect(() => {
		// Only show on client side
		if (typeof window === "undefined") return;

		const hasConsent = localStorage.getItem(CONSENT_KEY);

		if (!hasConsent) {
			setShowBanner(true);
		}
	}, []);

	const handleAccept = () => {
		if (typeof window !== "undefined") {
			localStorage.setItem(CONSENT_KEY, "given");
			localStorage.setItem(ANALYTICS_CONSENT_KEY, "accepted");
			setShowBanner(false);
			posthog.opt_in_capturing();
		}
	};

	const handleReject = () => {
		if (typeof window !== "undefined") {
			localStorage.setItem(CONSENT_KEY, "given");
			localStorage.setItem(ANALYTICS_CONSENT_KEY, "rejected");
			setShowBanner(false);
			posthog.opt_out_capturing();
		}
	};

	if (!showBanner) return null;

	return (
		<div className="fixed bottom-0 left-0 right-0 bg-accent p-4 z-50 transition-all border-t border-primary shadow-lg">
			<div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
				<div className="flex-1">
					<p className="text-sm font-medium">
						Nós usamos cookies para analisar o tráfego do site e melhorar sua
						experiência. Ao aceitar, você concorda com o nosso uso de cookies de
						análise.
					</p>
				</div>
				<div className="flex gap-3">
					<Button variant="secondary" onClick={handleReject}>
						Rejeitar
					</Button>
					<Button onClick={handleAccept}>Aceitar</Button>
				</div>
			</div>
		</div>
	);
}
